// OfferSection.js
import React from 'react';
import OfferProductCard from '../../OfferProductCard/OfferProductCard';


function OfferSection({ title, products }) {
    return (
        <div className="flex justify-center items-start my-2">
            <div>
                <h1 className='text-lg text-center md:text-start md:ext-3xl font-semibold py-3 ml-5'>{title}</h1>
                <OfferProductCard products={products} />
            </div>
        </div>
    );
}

export default OfferSection;
